import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { DeletedPlanningDataService } from '../data-services/deleted-planning-data.service';
import { DeletedPlanningModel } from '../business-entities/delete-planning-model';

@Injectable({
  providedIn: 'root'
})
export class DeletedPlanningService {
  filterTypeId: number = 0;
  dealerId:string = '';
  deletedPlanningList: DeletedPlanningModel[];
 
  constructor(private service : DeletedPlanningDataService) { }

async getDeletedPlanningList(data):Promise<any>{
  await this.service.getDeletedPlanningList(data).then(
    (res:GenericResponse<Array<DeletedPlanningModel>>)=>{
      this.deletedPlanningList = res.responseObject;
    }
  );
  return this.deletedPlanningList;
}

}
